import { inject, Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { AuthService } from 'svnxii-modules/auth/services';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class OnboardingGuard implements CanActivate {
  router = inject(Router);
  authService = inject(AuthService);

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> {
    return this.authService.checkReadiness().pipe(
      map((readiness) => {
        if (readiness.isComplete === true || readiness.status === 'Completed') {
          return this.router.createUrlTree(['/']);
        }
        return true;
      }),
      catchError(() => of(true)),
    );
  }
}
